import AdminRolesContainer from './adminRoles.container';

export default AdminRolesContainer;
